import { get, post, put, deleteRequest } from "utils/api";

export const shorturldetail = async (shorturlcode, shorturldata = {}) => {
  const shorturlResponse = await put(
    `/shortUrl/check/${shorturlcode}`,
    shorturldata
  );
  return shorturlResponse?.data?.data;
};
